/**
 * Environment Configuration
 * 
 * This file contains all environment-specific settings.
 * Easily modify these values for local development and testing.
 */

const config = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_BASE_URL || 'https://ikmpt.dsrs.illinois.edu',
  API_TIMEOUT: 0,
  
  // Local Development Override
  // Uncomment and modify for local backend testing
  //API_BASE_URL: 'http://localhost:8000',
  
  // Application Settings
  APP_NAME: 'iKompete',
  VERSION: '1.18.0',
  
  // Feature Flags
  FEATURES: {
    REGISTRATION_ENABLED: false,
    FORGOT_PASSWORD_ENABLED: true,
    ADMIN_PANEL_ENABLED: true,
    TEAM_MODE_ENABLED: true
  },
  
  // Authentication
  TOKEN_STORAGE_KEY: 'auth_token',
  SESSION_TIMEOUT: 3600000, // 1 hour in milliseconds
  
  
  // UI Configuration
  UI: {
    ITEMS_PER_PAGE: 10,
    DEBOUNCE_DELAY: 300,
    TOAST_DURATION: 5000,

    // Global notification banners.
    // - `id` is used for dismiss persistence (change id to re-show after dismissal)
    // - `enabled` toggles visibility
    // - `dismissible` allows users to close the banner
    // - `severity` controls styling
    BANNERS: {
      maintenance: {
        id: 'maintenance-4', // increase everytime
        enabled: false,
        severity: 'error', // 'warning' | 'error'
        message: ' ⚠️ The platform is currently under maintenance. Some functionality may be unavailable. ⚠️',
        dismissible: false,
      },
      announcement: {
        id: 'announcement-1',
        enabled: false,
        severity: 'info', // 'info'
        message: 'Welcome to iKompete! Check out the latest competitions on the dashboard.',
        dismissible: true,
      },
    },
  },
  
  // Development Settings
  DEV: {
    ENABLE_LOGGING: process.env.NODE_ENV === 'development'
  }
};

export default config;
